import { Group } from "three";
import Ring from "./Ring.js";
import { config, getPhrasesInPercent } from "./config";

const count = config.rings.count;

export default class Rings extends Group {
    constructor() {
        super();

        this.rings = [];
    }

    update(progress) {
        if (!this.rings.length && progress > getPhrasesInPercent().entering) {
            this._createRings();
        }

        this.rings.forEach((ring) => {
            ring.update(progress);
        });
    }

    destroy() {
        this.rings.forEach((ring) => {
            ring.destroy();
        });
    }

    _createRings() {
        for (let i = 0; i < count; i++) {
            const ring = new Ring();
            this.add(ring);
            this.rings.push(ring);
        }
    }

    set strokeWidth(value) {
        this.rings.forEach((ring) => {
            ring.strokeWidth = value;
        });
    }

    set count(value) {
        if (value === this.rings.length) return;
        if (value > this.rings.length) {
            for (let i = this.rings.length; i < value; i++) {
                const ring = new Ring();
                this.add(ring);
                this.rings.push(ring);
            }
        } else {
            for (let i = this.rings.length; i > value; i--) {
                const ring = this.rings.pop();
                ring.destroy?.();
                this.remove(ring);
            }
        }
    }
}
